import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import url from 'url';
import { getCurrentUser } from '../../../redux-modules/current-user';
import CustomerActions from '../../../redux-modules/customers';
import OrganizationActions from '../../../redux-modules/organizations';
import Redirect from '../../../common/components/Redirect';
import LoadingView from '../../../common/components/LoadingView';
import withQuery from '../../../common/components/withQuery';

// find the organization's Business-type address; some orgs only have a
// Mailing address on file, so don't just assume addresses[0] is it
const getBusinessStateCode = organization => {
  const addresses = (organization && organization.addresses) || [];
  const businessAddress = addresses.find(
    address => address.type && address.type.toLowerCase() === 'business'
  );
  return businessAddress && businessAddress.stateCode;
};

class LoggedInRedirect extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
    }),
    id: PropTypes.string,
    currentUser: PropTypes.shape({
      id: PropTypes.string,
    }),
    actions: PropTypes.shape({
      customer: PropTypes.objectOf(PropTypes.func),
      organization: PropTypes.objectOf(PropTypes.func),
    }),
  };

  state = {
    resolvedReturnUrl: null,
  };

  componentDidMount() {
    const { location, id, currentUser, actions } = this.props;
    const query = location.query || {};
    if (!query.returnUrl) {
      // nothing async to resolve - render() redirects immediately
      return;
    }

    const userId = id || (currentUser && currentUser.id);
    if (!userId) {
      // no user to look up (e.g. an unauthenticated visitor's returnUrl) -
      // skip the doomed fetch and redirect right away
      this.redirectWithStateCode(null);
      return;
    }

    actions.customer
      .get(userId)
      .then(custResult => {
        const customer =
          custResult && !custResult.hasError && custResult.payload
            ? custResult.payload.json
            : null;
        const orgKey =
          customer && customer.organization && customer.organization.key;
        const personalStateCode =
          customer &&
          customer.personalAddress &&
          customer.personalAddress.stateCode;

        if (!orgKey) {
          this.redirectWithStateCode(personalStateCode);
          return;
        }

        actions.organization
          .get(orgKey)
          .then(orgResult => {
            const organization =
              orgResult && !orgResult.hasError && orgResult.payload
                ? orgResult.payload.json
                : null;
            const businessStateCode = getBusinessStateCode(organization);
            this.redirectWithStateCode(businessStateCode || personalStateCode);
          })
          .catch(() => this.redirectWithStateCode(personalStateCode));
      })
      .catch(() => this.redirectWithStateCode(null));
  }

  redirectWithStateCode = stateCode => {
    const { location, id, currentUser } = this.props;
    const query = location.query || {};
    const returnUrl = url.parse(query.returnUrl, true);
    // url.format() prefers .search over .query if .search is still set
    // (which url.parse always sets) - clear it so our updated .query object
    // is actually the one that gets serialized
    returnUrl.search = null;
    returnUrl.query = { ...returnUrl.query, cst: id || currentUser.id };
    if (stateCode) {
      returnUrl.query.state = stateCode;
    }
    this.setState({ resolvedReturnUrl: url.format(returnUrl) });
  };

  render() {
    const { location } = this.props;
    const query = location.query || {};

    if (!query.returnUrl) {
      return <Redirect external to="/account" />;
    }

    if (this.state.resolvedReturnUrl) {
      return <Redirect external to={this.state.resolvedReturnUrl} />;
    }

    return <LoadingView />;
  }
}

export { LoggedInRedirect };

const mapDispatchToProps = dispatch => ({
  actions: {
    customer: bindActionCreators(CustomerActions, dispatch),
    organization: bindActionCreators(OrganizationActions, dispatch),
  },
});

export default withQuery(
  connect(
    state => ({ currentUser: getCurrentUser(state) }),
    mapDispatchToProps
  )(LoggedInRedirect)
);



// WEBPACK FOOTER //
// ./src/App/auth/Views/LoggedInRedirect.js